<template>
  <BaseModal ref="modal" modal-classes="max-w-md mx-auto" @modal-after-leave="$emit('closed')">
    <template #header>
      <span class="block text-xs text-gray-700 uppercase tracking-wider">order item</span>
      <h3 class="text-2xl text-gray-900">Προδιαγραφές</h3>
    </template>

    <template #default="modalProps">
      <form @submit.prevent="update" @click.stop>
        <BaseLayoutSpaced>
          <div v-if="edit" class="space-y-8">
            <div class="space-y-2">
              <textarea
                id="requirements"
                ref="requirements"
                v-model="data.requirements"
                name="requirements"
                class="input"
                rows="15"
                @blur="edit = false"
              />
            </div>
          </div>

          <div v-else class="min-h-96">
            <div
              class="p-2 whitespace-pre-wrap leading-normal rounded hover:bg-gray-300"
              v-html="mdRequirements"
              @click="doEdit"
            />
          </div>
          <div class="flex space-x-2 items-baseline">
            <BaseButton primary> Update </BaseButton>
            <BaseButton ghost type="button" @click="modalProps.close"> Close </BaseButton>
          </div>
        </BaseLayoutSpaced>
      </form>
    </template>
  </BaseModal>
</template>

<script>
import { marked } from 'marked';

const renderer = new marked.Renderer();
renderer.list = (body, ordered) => {
  if (ordered) {
    return `<ol class="list-decimal list-inside">${body}</ol>`;
  }
  return `<ul class="list-disc list-inside">${body}</ul>`;
};

export default {
  props: {
    orderItem: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    data: {
      requirements: '',
    },
    edit: false,
  }),
  computed: {
    mdRequirements() {
      if (!this.data.requirements) return 'Add requirements';
      return marked(this.data.requirements, { renderer });
    },
  },
  created() {
    this.data = { ...this.data, ...this.orderItem };
  },
  methods: {
    doEdit() {
      this.edit = true;
    },
    update() {
      this.$emit('update', this.data);

      this.$refs.modal.doClose();
    },
  },
};
</script>
